let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0aBdS")).then(() => parcelRequire('8cMxq'));